import {isNil} from 'ramda';

import type {
  FinancingControlDimensions,
  FinancingControlSelection,
} from './getFinancingControlLimits';

/** The floor-rule bracket for an offerable term and exact balloon coordinate, with no ceiling. */
export function getFinancingDownPaymentBracket(
  dimensions: FinancingControlDimensions,
  selection: FinancingControlSelection
): number | null {
  const cells = dimensions.availableFinancingCells;
  const downPaymentPercentage = selection.downPaymentPercentage;

  if (isNil(cells) || isNil(selection.termMonths) || isNil(downPaymentPercentage)) {
    return null;
  }

  return (
    cells
      .filter(
        (cell) =>
          dimensions.availableTerms.includes(cell.termMonths) &&
          cell.termMonths === selection.termMonths &&
          cell.balloonPaymentPercentage === selection.balloonPaymentPercentage &&
          cell.downPaymentPercentage <= downPaymentPercentage
      )
      .map((cell) => cell.downPaymentPercentage)
      .sort((left, right) => left - right)
      .at(-1) ?? null
  );
}
